import React from 'react';
import ClickPopover from '../../click-popover/ClickPopover';
import LongCard from '../comment-card/LongCard';
import { CardProps } from '../../../../utils/comments/types';

interface LongCommentPopoverProps extends CardProps {
    show: boolean,
    handleClose: (e: React.MouseEvent<HTMLDivElement>) => void
    anchorEl?: HTMLElement | null | undefined,
}

const LongCommentPopover = function LongCommentPopover(
    { comment, pageUrl, avatarSrc, show, targetName,
        isMobile = false, anchorEl, handleClose, }: LongCommentPopoverProps
) {
    if (!show) {
        return null;
    }

    const styles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const mobileStyles = {
        justifyContent: 'center',
        alignItems: 'center',
    };

    const popupStyles = isMobile ? mobileStyles : styles;

    return (
        <ClickPopover
            popoverId={comment.Key}
            openPopover={show}
            anchorEl={anchorEl}
            handleClose={handleClose}
            message={(
                <div
                    role="none"
                    onClick={handleClose}
                    onMouseLeave={handleClose}
                    onWheel={handleClose}
                >
                    <LongCard
                        pageUrl={pageUrl}
                        targetName={targetName}
                        avatarSrc={avatarSrc}
                        comment={comment}
                    />
                </div>
            )}
            popoverStyles={popupStyles}
            anchorReference="anchorEl"
            anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
            transformOrigin={{ horizontal: 'center', vertical: 'top' }}
        />
    );
};

export default LongCommentPopover;
